// extracted by css-extract-rspack-plugin
export default {"NavLink":"UJmHZ","NavLinkLabel":"h0vSY","NavLinkChevron":"zvCYe","NavLinkSection":"OegxB"};